<template>
  <div class="form" v-if="installApp">
    <p-install-app
      @continueInBrowser="goToLogin"
      :showTitle="true"
    ></p-install-app>
  </div>
  <div class="form" v-else-if="firstPage">
    <i-loading v-if="loading" />
    <h2 class="heading">
      <span>{{
        __("Please enter a company code, username and password")
      }}</span>
    </h2>
    <div class="p-d-flex p-flex-column form__wrapper">
      <!-- קוד חברה -->
      <div class="p-field p-fluid">
        <p-vue-input-text
          class="phone-number p-text-center p-inputtext-lg p-inputtext-bold p-inputtext-rounded"
          :class="{ 'p-invalid': errors.comp }"
          v-model="comp"
          :placeholder="__('Company code')"
          @keyup.enter="submitHandler"
        />
        <i-form-error :data="errors.comp" class="p-text-center" />
      </div>
      <!-- שם משתמש -->
      <div class="p-field p-fluid">
        <p-vue-input-text
          type="text"
          class="phone-number p-text-center p-inputtext-lg p-inputtext-bold p-inputtext-rounded"
          :class="{ 'p-invalid': errors.userName }"
          v-model="userName"
          :placeholder="__('Username')"
          @keyup.enter="submitHandler"
        />
        <i-form-error :data="errors.userName" class="p-text-center" />
      </div>
      <!-- סיסמה -->
      <div class="p-field p-fluid">
        <p-vue-input-text
          type="password"
          class="phone-number p-text-center p-inputtext-lg p-inputtext-bold p-inputtext-rounded"
          :class="{ 'p-invalid': errors.password }"
          v-model="password"
          :placeholder="__('password')"
          @keyup.enter="submitHandler"
        />
        <i-form-error :data="errors.password" class="p-text-center" />
      </div>
      <p-vue-button
        class="button p-button-lg p-button-rounded p-button-success"
        :label="__('Send')"
        @click="submitHandler"
      />
    </div>
  </div>
</template>

<script>
import PInstallApp from "@/components/partials/install-app";
import { mapState } from "vuex";
import { ValidationError } from "vue3-form-validation";
import { getWorkerData } from "@/services/service";
import { apiGetSessionToken } from "@/services/APointAPI";
import { __ } from "@/plugins/i18n/index";
export default {
  components: {
    PInstallApp,
  },
  data() {
    return {
      loading: false,
      comp: null,
      userName: null,
      password: null,
      valid: true,
      firstPage: true,
      errors: {
        comp: null,
        userName: null,
        password: null,
      },
      installApp: true,
    };
  },
  mounted() {
    const devicePlatform = window.device?.platform;
    const cordovaPlatform = window.cordova.platformId;
    if (
      cordovaPlatform == "browser" &&
      (devicePlatform == "Android" || devicePlatform == "iOS")
    )
      this.installApp = true;
    else this.installApp = false;
    this.comp = this.compID;
    this.userName = this.apiUserName;

    // if (
    //   window.location.host.includes("localhost:") ||
    //   window.location.host.substring(0, 10) === "10.11.171."
    // ) {
    //   this.comp = 999;
    //   this.userName = "דניאל";
    //   this.password = 1234;
    // }
  },
  methods: {
    isNotBrowser() {
      return window.cordova.platformId !== "browser";
    },
    goToLogin() {
      this.installApp = false;
    },
    submitHandler() {
      try {
        this.validateFields();

        if (this.valid) {
          this.loading = true;
          this.$store.commit("api/setSessionData", {
            compID: this.comp,
            User: { userName: this.userName, pswd: this.password },
          });
          this.getToken();
        }
      } catch (err) {
        // console.log(err);
        if (!(err instanceof ValidationError)) console.error(err);
      }
    },
    validateFields() {
      this.valid = true;
      this.errors = {
        comp: null,
        userName: null,
        password: null,
      };
      if (!this.comp) {
        this.valid = false;
        this.errors.comp = "Required field";
      }
      if (!this.userName) {
        this.valid = false;
        this.errors.userName = "Required field";
      }
      if (!this.password) {
        this.valid = false;
        this.errors.password = "Required field";
      }
    },
    getToken() {
      this.loading = true;
      apiGetSessionToken(this.compID, this.userName, this.password).then(
        (result) => {
          this.loading = false;
          if (result != "") {
            this.$store.commit("api/setSessionData", {
              sessionToken: result,
              loggedIn: true,
            });
            getWorkerData().then(() => {
              this.$router.push({ name: "Dashboard" });
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: __("Login error"),
              detail: __(
                "One or more of the identifying information you typed incorrectly"
              ),
              life: 5000,
            });
            this.password = null;
          }
        }
      );
    },
  },
  computed: {
    ...mapState({
      compID: (state) => state.api.compID,
      apiUserName: (state) => state.api?.User?.userName,
    }),
  },
};
</script>

<style scoped>
@import "./style.module.css";
.openCallService {
  text-align: center;
  font-size: 16px;
  cursor: pointer;
  text-decoration: underline;
}

.dialog__close .svg {
  width: 15px;
  height: 15px;
}
</style>
